<template>
  <button type="button" @click="expandirToggle" id="expandir" class="no-print botao botao_sem-preenchimento botao_medio botao_icone">
    <i class="fal fa-expand-arrows"></i>
    <i class="fal fa-compress-alt"></i>
  </button>
</template>

<script>
export default {
  methods: {
    expandirToggle() {
      let cssClass = document.body.className;

      if (cssClass.indexOf('expandido') === -1) {
        cssClass += ' expandido';
      } else {
        cssClass = cssClass.replace(' expandido', '');
      }

      document.body.className = cssClass;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ExpandirConteudo.vue?18f04506